import React from 'react';
import { DiagnosisCodeEditTemplate } from 'themes/application/diagnosis-code/pages';
import { observer } from 'mobx-react';
import { DiagnosisCodeEditViewStore } from 'application/diagnosis-code/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore) => new DiagnosisCodeEditViewStore(rootStore), 'diagnosisCodeEditViewStore')
@observer
class DiagnosisCodeEdit extends React.Component {
    render() {
        return <DiagnosisCodeEditTemplate {...this.props} />
    }
}

export default DiagnosisCodeEdit;